import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Long2qws0ah9gnpki as Long,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  equals2au1ep9vhcato as equals,
  Enum3alwj03lh1n41 as Enum,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Result3t1vadv16kmzk as Result,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  QueryListEndpointCacheStrategy1c0c59lgyft8l as QueryListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
  IDateTimeProvider3dxwb1v3szpn5 as IDateTimeProvider,
} from './Shared7Punches-common-base.mjs';
import {
  Formats_getInstance1irqalmffdr0o as Formats_getInstance,
  format2n4cpzximuj7a as format,
} from './Kotlin-DateTime-library-kotlinx-datetime.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
import { ICompanyAccessor1vx4gxjmpol6a as ICompanyAccessor } from './Shared7Punches-data-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiAvailability, 'ApiAvailability', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForClass(ApiAvailabilityRequestFilters, 'ApiAvailabilityRequestFilters', ApiAvailabilityRequestFilters);
initMetadataForClass(ApiAvailabilityStatus, 'ApiAvailabilityStatus', VOID, Enum);
initMetadataForLambda(AvailabilityRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [2]);
initMetadataForLambda(AvailabilityRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForInterface(IAvailabilityAccessor, 'IAvailabilityAccessor');
initMetadataForInterface(IAvailabilityMutator, 'IAvailabilityMutator', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(AvailabilityRepository, 'AvailabilityRepository', VOID, VOID, [IAvailabilityAccessor, IAvailabilityMutator], [2, 1, 3]);
initMetadataForInterface(IAvailabilityRemoteSource, 'IAvailabilityRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForCoroutine($getAvailabilityRequestsCOROUTINE$2, CoroutineImpl);
initMetadataForClass(AvailabilityRemoteSource, 'AvailabilityRemoteSource', VOID, VOID, [IAvailabilityRemoteSource], [1, 2]);
initMetadataForClass(Availability, 'Availability');
initMetadataForClass(AvailabilityFilters, 'AvailabilityFilters');
initMetadataForClass(AvailabilityStatus, 'AvailabilityStatus', VOID, Enum);
initMetadataForInterface(IGetPendingAvailabilityRequestCount, 'IGetPendingAvailabilityRequestCount');
initMetadataForClass(GetPendingAvailabilityRequestCount, 'GetPendingAvailabilityRequestCount', VOID, VOID, [IGetPendingAvailabilityRequestCount]);
//endregion
function toApi(_this__u8e3s4) {
  return new ApiAvailabilityRequestFilters(toApi_0(_this__u8e3s4.m84_1), _this__u8e3s4.n84_1);
}
function toDomain(_this__u8e3s4) {
  return new Availability(_this__u8e3s4.o84_1);
}
function toApi_0(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.l2_1) {
    case 0:
      tmp = ApiAvailabilityStatus_PENDING_getInstance();
      break;
    case 1:
      tmp = ApiAvailabilityStatus_APPROVED_getInstance();
      break;
    case 2:
      tmp = ApiAvailabilityStatus_DECLINED_getInstance();
      break;
    case 3:
      tmp = ApiAvailabilityStatus_UNKNOWN_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.data.availability.data.model.ApiAvailability', this, 1);
  tmp0_serialDesc.wy('id', false);
  this.p84_1 = tmp0_serialDesc;
}
protoOf($serializer).q84 = function (encoder, value) {
  var tmp0_desc = this.p84_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.o84_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.q84(encoder, value instanceof ApiAvailability ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.p84_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiAvailability_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.p84_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiAvailability_init_$Init$(seen0, id, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().p84_1);
  }
  $this.o84_1 = id;
  return $this;
}
function ApiAvailability_init_$Create$(seen0, id, serializationConstructorMarker) {
  return ApiAvailability_init_$Init$(seen0, id, serializationConstructorMarker, objectCreate(protoOf(ApiAvailability)));
}
function ApiAvailability(id) {
  this.o84_1 = id;
}
protoOf(ApiAvailability).toString = function () {
  return 'ApiAvailability(id=' + this.o84_1.toString() + ')';
};
protoOf(ApiAvailability).hashCode = function () {
  return this.o84_1.hashCode();
};
protoOf(ApiAvailability).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAvailability))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAvailability ? other : THROW_CCE();
  if (!this.o84_1.equals(tmp0_other_with_cast.o84_1))
    return false;
  return true;
};
function ApiAvailabilityRequestFilters(status, startDate) {
  status = status === VOID ? null : status;
  startDate = startDate === VOID ? null : startDate;
  this.r84_1 = status;
  this.s84_1 = startDate;
}
protoOf(ApiAvailabilityRequestFilters).toString = function () {
  return 'ApiAvailabilityRequestFilters(status=' + toString(this.r84_1) + ', startDate=' + toString(this.s84_1) + ')';
};
protoOf(ApiAvailabilityRequestFilters).hashCode = function () {
  var result = this.r84_1 == null ? 0 : this.r84_1.hashCode();
  result = imul(result, 31) + (this.s84_1 == null ? 0 : this.s84_1.hashCode()) | 0;
  return result;
};
protoOf(ApiAvailabilityRequestFilters).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiAvailabilityRequestFilters))
    return false;
  var tmp0_other_with_cast = other instanceof ApiAvailabilityRequestFilters ? other : THROW_CCE();
  if (!equals(this.r84_1, tmp0_other_with_cast.r84_1))
    return false;
  if (!equals(this.s84_1, tmp0_other_with_cast.s84_1))
    return false;
  return true;
};
var ApiAvailabilityStatus_PENDING_instance;
var ApiAvailabilityStatus_APPROVED_instance;
var ApiAvailabilityStatus_DECLINED_instance;
var ApiAvailabilityStatus_UNKNOWN_instance;
var ApiAvailabilityStatus_entriesInitialized;
function ApiAvailabilityStatus_initEntries() {
  if (ApiAvailabilityStatus_entriesInitialized)
    return Unit_instance;
  ApiAvailabilityStatus_entriesInitialized = true;
  ApiAvailabilityStatus_PENDING_instance = new ApiAvailabilityStatus('PENDING', 0, 0);
  ApiAvailabilityStatus_APPROVED_instance = new ApiAvailabilityStatus('APPROVED', 1, 1);
  ApiAvailabilityStatus_DECLINED_instance = new ApiAvailabilityStatus('DECLINED', 2, 2);
  ApiAvailabilityStatus_UNKNOWN_instance = new ApiAvailabilityStatus('UNKNOWN', 3, -1);
}
function ApiAvailabilityStatus(name, ordinal, apiValue) {
  Enum.call(this, name, ordinal);
  this.v84_1 = apiValue;
}
function ApiAvailabilityStatus_PENDING_getInstance() {
  ApiAvailabilityStatus_initEntries();
  return ApiAvailabilityStatus_PENDING_instance;
}
function ApiAvailabilityStatus_APPROVED_getInstance() {
  ApiAvailabilityStatus_initEntries();
  return ApiAvailabilityStatus_APPROVED_instance;
}
function ApiAvailabilityStatus_DECLINED_getInstance() {
  ApiAvailabilityStatus_initEntries();
  return ApiAvailabilityStatus_DECLINED_instance;
}
function ApiAvailabilityStatus_UNKNOWN_getInstance() {
  ApiAvailabilityStatus_initEntries();
  return ApiAvailabilityStatus_UNKNOWN_instance;
}
function AvailabilityRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.e85_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AvailabilityRepository$cacheStrategy$slambda).h85 = function (_unused_var__etf5q3, data, $completion) {
  var tmp = this.i85(_unused_var__etf5q3, data, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(AvailabilityRepository$cacheStrategy$slambda).i9 = function (p1, p2, $completion) {
  var tmp = p1 instanceof AvailabilityFilters ? p1 : THROW_CCE();
  return this.h85(tmp, (!(p2 == null) ? isInterface(p2, KtList) : false) ? p2 : THROW_CCE(), $completion);
};
protoOf(AvailabilityRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.e85_1.k85_1.m2u(this.g85_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(AvailabilityRepository$cacheStrategy$slambda).i85 = function (_unused_var__etf5q3, data, completion) {
  var i = new AvailabilityRepository$cacheStrategy$slambda(this.e85_1, completion);
  i.f85_1 = _unused_var__etf5q3;
  i.g85_1 = data;
  return i;
};
function AvailabilityRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new AvailabilityRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (_unused_var__etf5q3, data, $completion) {
    return i.h85(_unused_var__etf5q3, data, $completion);
  };
  l.$arity = 2;
  return l;
}
function AvailabilityRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.v85_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(AvailabilityRepository$cacheStrategy$slambda_1).x85 = function (filter, $completion) {
  var tmp = this.y85(filter, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(AvailabilityRepository$cacheStrategy$slambda_1).h9 = function (p1, $completion) {
  return this.x85(p1 instanceof AvailabilityFilters ? p1 : THROW_CCE(), $completion);
};
protoOf(AvailabilityRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.v85_1.j85_1.z85(toApi(this.w85_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(AvailabilityRepository$cacheStrategy$slambda_1).y85 = function (filter, completion) {
  var i = new AvailabilityRepository$cacheStrategy$slambda_1(this.v85_1, completion);
  i.w85_1 = filter;
  return i;
};
function AvailabilityRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new AvailabilityRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function (filter, $completion) {
    return i.x85(filter, $completion);
  };
  l.$arity = 1;
  return l;
}
function AvailabilityRepository$cacheStrategy$lambda(this$0) {
  return function () {
    return new AvailabilityFilters(AvailabilityStatus_PENDING_getInstance(), this$0.l85_1.g37());
  };
}
function AvailabilityRepository$cacheStrategy$lambda_0(it) {
  return toDomain(it);
}
function AvailabilityRepository$cacheStrategy$lambda_1($this$QueryListEndpointCacheStrategy) {
  return $this$QueryListEndpointCacheStrategy.a86_1;
}
function AvailabilityRepository(remoteSource, localSource, dateTimeProvider) {
  this.j85_1 = remoteSource;
  this.k85_1 = localSource;
  this.l85_1 = dateTimeProvider;
  var tmp = this;
  var tmp0_localDataFlow = this.k85_1.n18();
  var tmp_0 = AvailabilityRepository$cacheStrategy$slambda_0(this, null);
  var tmp_1 = AvailabilityRepository$cacheStrategy$slambda_2(this, null);
  var tmp_2 = AvailabilityRepository$cacheStrategy$lambda(this);
  var tmp_3 = AvailabilityRepository$cacheStrategy$lambda_0;
  tmp.m85_1 = new QueryListEndpointCacheStrategy(tmp0_localDataFlow, tmp_0, tmp_1, tmp_2, tmp_3, AvailabilityRepository$cacheStrategy$lambda_1);
}
function IAvailabilityRemoteSource() {
}
function AvailabilityRemoteSource$getAvailabilityRequests$lambda($filters) {
  return function ($this$get, it) {
    var tmp0_safe_receiver = $filters.r84_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$get.o44_1.r3q('status', tmp0_safe_receiver.v84_1.toString());
    }
    var tmp1_safe_receiver = $filters.s84_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$get.o44_1.r3q('week_to_include_repeating_gte', format(tmp1_safe_receiver, Formats_getInstance().w2c()));
    }
    return Unit_instance;
  };
}
function AvailabilityRemoteSource$getAvailabilityRequests$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $getAvailabilityRequestsCOROUTINE$2(_this__u8e3s4, filters, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j86_1 = _this__u8e3s4;
  this.k86_1 = filters;
}
protoOf($getAvailabilityRequestsCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.l86_1 = this.j86_1.g88_1;
          this.n8_1 = 1;
          suspendResult = this.j86_1.h88_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.m86_1 = suspendResult;
          this.n86_1 = this.m86_1.toString();
          this.o86_1 = 'company/' + this.n86_1 + '/availabilities';
          var tmp_1 = this;
          tmp_1.p86_1 = ApiVersion_FEBRUARY_2026_getInstance();
          var tmp_2 = this;
          tmp_2.q86_1 = AvailabilityRemoteSource$getAvailabilityRequests$lambda(this.k86_1);
          this.r86_1 = this.l86_1;
          this.s86_1 = this.o86_1;
          this.t86_1 = this.p86_1;
          this.u86_1 = this.q86_1;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.w86_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.x86_1 = this.r86_1.f6l_1;
          var tmp_5 = this;
          tmp_5.y86_1 = buildV2Path(this.r86_1, this.s86_1);
          this.z86_1 = this.x86_1;
          this.a87_1 = this.y86_1;
          var tmp_6 = this;
          tmp_6.b87_1 = this.z86_1;
          this.c87_1 = this.b87_1;
          var tmp_7 = this;
          tmp_7.d87_1 = this.c87_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.a87_1);
          headers(this_0, AvailabilityRemoteSource$getAvailabilityRequests$lambda_0(this.t86_1));
          this_0.z5n(this.u86_1);
          tmp_8.e87_1 = this_0;
          this.f87_1 = this.d87_1;
          this.g87_1 = this.e87_1;
          this.g87_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.h87_1 = this.f87_1;
          var tmp_10 = this;
          tmp_10.i87_1 = this.g87_1;
          this.j87_1 = this.h87_1;
          this.k87_1 = this.i87_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.k87_1, this.j87_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.l87_1 = suspendResult;
          var tmp_11 = this;
          this.w86_1;
          var value = this.l87_1;
          tmp_11.v86_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.m87_1 = this.q8_1;
            var tmp_13 = this;
            throw this.m87_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.n87_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.n87_1;
              tmp_15.v86_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.o87_1 = this.v86_1;
          this.p87_1 = this.o87_1;
          this.q87_1 = Result__exceptionOrNull_impl_p6xea9(this.p87_1);
          if (this.q87_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.p87_1);
            tmp_16.s87_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.t87_1 = this.s87_1;
            var tmp_18 = this;
            tmp_18.u87_1 = this.t87_1;
            this.v87_1 = this.u87_1;
            this.w87_1 = this.v87_1.c4u().z43_1;
            var containsArg = this.w87_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.z87_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.b88_1 = this.v87_1;
                this.c88_1 = this.b88_1;
                this.n8_1 = 7;
                var tmp_21 = this.c88_1.y4u();
                var tmp_22 = getKClass(KtList);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAvailability), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.d88_1 = this.v87_1;
                this.e88_1 = this.d88_1;
                this.n8_1 = 6;
                var tmp_26 = this.e88_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.f88_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.v87_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.q87_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.r87_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.f88_1;
          tmp_32.x87_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiAvailability), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.a88_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.a88_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.a88_1;
          var tmp_37 = this;
          this.z87_1;
          tmp_37.y87_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.y87_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.y87_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.x87_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.r87_1 = new Result(this.x87_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.r87_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function AvailabilityRemoteSource(apiClient, sessionDataProvider) {
  this.g88_1 = apiClient;
  this.h88_1 = sessionDataProvider;
}
protoOf(AvailabilityRemoteSource).z85 = function (filters, $completion) {
  var tmp = new $getAvailabilityRequestsCOROUTINE$2(this, filters, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_availabilityModule() {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  return availabilityModule;
}
var availabilityModule;
function availabilityModule$lambda($this$module) {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = availabilityModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IAvailabilityRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp4 = new TypeQualifier(getKClass(Availability));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = availabilityModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IListLocalSource), tmp4, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = availabilityModule$lambda$lambda_1;
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Singleton_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(AvailabilityRepository), null, definition_0, kind_1, secondaryTypes_1);
  var factory_1 = new SingleInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_1);
  }
  var tmp = new KoinDefinition($this$module, factory_1);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$13 = [getKClass(IAvailabilityAccessor), getKClass(IAvailabilityMutator)];
  binds(tmp, tmp$ret$13);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = availabilityModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IGetPendingAvailabilityRequestCount), null, tmp2_0, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  return Unit_instance;
}
function availabilityModule$lambda$lambda($this$factory, it) {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new AvailabilityRemoteSource(tmp, tmp$ret$1);
}
function availabilityModule$lambda$lambda_0($this$single, it) {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('availability', tmp$ret$0);
}
function availabilityModule$lambda$lambda_1($this$single, it) {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IAvailabilityRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Availability));
  var tmp_0 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$3 = $this$single.q1d(getKClass(IDateTimeProvider), null, null);
  return new AvailabilityRepository(tmp, tmp_0, tmp$ret$3);
}
function availabilityModule$lambda$lambda_2($this$factory, it) {
  _init_properties_AvailabilityModule_kt__qzy8lj();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ICompanyAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IAvailabilityAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(IDateTimeProvider), null, null);
  return new GetPendingAvailabilityRequestCount(tmp, tmp_0, tmp$ret$2);
}
var properties_initialized_AvailabilityModule_kt_5ny7ef;
function _init_properties_AvailabilityModule_kt__qzy8lj() {
  if (!properties_initialized_AvailabilityModule_kt_5ny7ef) {
    properties_initialized_AvailabilityModule_kt_5ny7ef = true;
    availabilityModule = module_0(VOID, availabilityModule$lambda);
  }
}
function IAvailabilityAccessor() {
}
function Availability(id) {
  this.a86_1 = id;
}
protoOf(Availability).toString = function () {
  return 'Availability(id=' + this.a86_1.toString() + ')';
};
protoOf(Availability).hashCode = function () {
  return this.a86_1.hashCode();
};
protoOf(Availability).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Availability))
    return false;
  var tmp0_other_with_cast = other instanceof Availability ? other : THROW_CCE();
  if (!this.a86_1.equals(tmp0_other_with_cast.a86_1))
    return false;
  return true;
};
function AvailabilityFilters(status, startDate) {
  this.m84_1 = status;
  this.n84_1 = startDate;
}
protoOf(AvailabilityFilters).toString = function () {
  return 'AvailabilityFilters(status=' + this.m84_1.toString() + ', startDate=' + this.n84_1.toString() + ')';
};
protoOf(AvailabilityFilters).hashCode = function () {
  var result = this.m84_1.hashCode();
  result = imul(result, 31) + this.n84_1.hashCode() | 0;
  return result;
};
protoOf(AvailabilityFilters).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AvailabilityFilters))
    return false;
  var tmp0_other_with_cast = other instanceof AvailabilityFilters ? other : THROW_CCE();
  if (!this.m84_1.equals(tmp0_other_with_cast.m84_1))
    return false;
  if (!this.n84_1.equals(tmp0_other_with_cast.n84_1))
    return false;
  return true;
};
var AvailabilityStatus_PENDING_instance;
var AvailabilityStatus_APPROVED_instance;
var AvailabilityStatus_DECLINED_instance;
var AvailabilityStatus_UNKNOWN_instance;
var AvailabilityStatus_entriesInitialized;
function AvailabilityStatus_initEntries() {
  if (AvailabilityStatus_entriesInitialized)
    return Unit_instance;
  AvailabilityStatus_entriesInitialized = true;
  AvailabilityStatus_PENDING_instance = new AvailabilityStatus('PENDING', 0);
  AvailabilityStatus_APPROVED_instance = new AvailabilityStatus('APPROVED', 1);
  AvailabilityStatus_DECLINED_instance = new AvailabilityStatus('DECLINED', 2);
  AvailabilityStatus_UNKNOWN_instance = new AvailabilityStatus('UNKNOWN', 3);
}
function AvailabilityStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function AvailabilityStatus_PENDING_getInstance() {
  AvailabilityStatus_initEntries();
  return AvailabilityStatus_PENDING_instance;
}
function IAvailabilityMutator() {
}
function GetPendingAvailabilityRequestCount(companyAccessor, availabilityAccessor, dateTimeProvider) {
  this.i88_1 = companyAccessor;
  this.j88_1 = availabilityAccessor;
  this.k88_1 = dateTimeProvider;
}
function IGetPendingAvailabilityRequestCount() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
//endregion
//region block: exports
export {
  get_availabilityModule as get_availabilityModule325yej4udz930,
  IAvailabilityMutator as IAvailabilityMutator6scppwkpzt4a,
  IGetPendingAvailabilityRequestCount as IGetPendingAvailabilityRequestCount1l41jnqopld96,
};
//endregion

